import script from "./NavigationPetugas.vue?vue&type=script&setup=true&lang=js"
export * from "./NavigationPetugas.vue?vue&type=script&setup=true&lang=js"

import "./NavigationPetugas.vue?vue&type=style&index=0&id=643b428f&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-643b428f"]])

export default __exports__